module.exports = __webpack_public_path__ + "static/media/mock-teytu1.c59054bd.png";